import { render, staticRenderFns } from "./StoryEditor.vue?vue&type=template&id=5ec403b0&scoped=true&"
import script from "./StoryEditor.vue?vue&type=script&lang=js&"
export * from "./StoryEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec403b0",
  null
  
)

export default component.exports